<!-- DoubleCardVertical.vue - 双人名片竖向展示主组件 -->
<template>
	<div class="double-cards-vertical">
		<!-- 第一位：郭洪铨 -->
		<div class="card-wrapper">
			<flip-card :card-data="person1" :card-type="'first'" @qr-click="handleQrClick" />
			<div class="hint-wrapper">
				<div class="flip-hint">{{ flipHintText }}</div>
			</div>
		</div>

		<!-- 第二位：陈思羽 -->
		<div class="card-wrapper">
			<flip-card :card-data="person2" :card-type="'second'" @qr-click="handleQrClick" />
			<div class="hint-wrapper">
				<div class="flip-hint">{{ flipHintText }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FlipCard from './businessCard/FlipCard.vue';

	export default {
		name: 'DoubleCardVertical',
		components: {
			FlipCard
		},
		data() {
			return {
				flipHintText: '💡 鼠标悬停 / 点击卡片 → 翻转查看背面',
				isTouchDevice: false,
				person1: {
					name: '郭洪铨',
					title: '全栈开发工程师 · 毕业设计先锋',
					email: '2904051106@qq.com',
					phone: '+86 18133560004',
					links: [{
							icon: '🤖',
							text: 'http://123.57.143.201:8080/'
						},
						{
							icon: '🖥️',
							text: 'aidea1.cn/'
						}
					],
					location: '河北 · 沧州 / 新华区',
					skills: ['Python', 'Java', 'React', 'Spring Boot', 'Docker', 'PyTorch', 'MySQL', 'K8s'],
					badge: '#毕业设计 · 智能推荐系统 & 医疗数据平台',
					education: '2017.09 - 2022.03 | 软件工程（本科）',
					courses: 'Web开发、数据结构、离散数学、SQL数据库、Java、线性代数、C#、Python数据分析',
					experiences: [{
						icon: '💼',
						text: '天津神州浩天科技有限公司 · Java开发工程师 (2022.09 - 2025.02)'
					}],
					projects: [
						'南京医院手机报销系统 · 核心模块设计与接口开发',
						'安康高新医院手机报销系统 · 全流程优化，日均处理单据2000+'
					],
					interests: '分布式系统, 边缘计算, AI Agent + 医疗信息化',
					socialLinks: [
						'📘 AI Demo: http://123.57.143.201:8080/',
						'💻 毕设系统: aidea1.cn/'
					],
					footer: '© 2025 郭洪铨 | 代码改变世界 · 创新驱动未来 | 智能医疗/推荐系统',
					portfolioUrl: 'https://123.57.143.201/',
					avatarSvg: 'M4 6h16v10H4V6zm2 2v6h12V8H6zm14 12H4v-2h16v2z M8 10h8v2H8z M12 14c0.83 0 1.5-0.67 1.5-1.5S12.83 11 12 11s-1.5 0.67-1.5 1.5S11.17 14 12 14z',
					backIconSvg: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 13c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.8 2.04-2.78 3.5-5.11 3.5z',
					binaryFront: '01001110 01000101 01010100\n01000011 01010011 00100000',
					binaryBack: '11010010 10110110 10001101'
				},
				person2: {
					name: '王義曦',
					title: '写作老师 | 硕士',
					phone: '962027221',
					email: '962027221@qq.com',
					// phone: '+86 13812348888',
					links: [{
							icon: '💻',
							text: 'aidea1.cn'
						},
						{
							icon: '🌐',
							text: 'aidea1.cn'
						}
					],
					location: '河北 · 唐山',
					skills: ['Go', 'Kubernetes', 'Microservices', 'Redis', 'Kafka', 'AWS', 'DevOps', 'gRPC'],
					badge: '#高并发系统 · 云原生架构设计',
					education: '2018.09 - 2022.06 |汉语言 · 硕士',
					courses: '语言学概论	、古代汉语、现代汉语、文学概论、大学写作/应用写作、美学概论		',
					experiences: [{
						icon: '🏢',
						text: ' '
					}],
					projects: [
						'读书破万卷，下笔如有神,汉语言文学专业出身，在经典名著中锻造文心。',
						'言之无文，行而不远，我追求语言的精准与美感，擅长将思想化为动人文字。',
						'传承不守旧，创新不忘本，愿以扎实的专业功底，为文化传播贡献一份力量。'
					],
					interests: '古典文学研读,吟诵, 创意写作与生活手札',
					socialLinks: [
						'📖 技术专栏: aidea1.cn',
						'🐙 GitHub: github.com/siyuchen'
					],
					footer: '© 2025 王義曦 | 美学概论 | 大学写作/应用写作',
					portfolioUrl: 'https://aidea1.cn',
					avatarSvg: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z',
					backIconSvg: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14h-2v-4H8v-2h2V9h2v2h2v2h-2v4z',
					binaryFront: '01001001 01001110 01001110\n01001111 01010110 01000001',
					binaryBack: '01100011 01101100 01101111 01110101 01100100'
				}
			};
		},
		mounted() {
			// 检测触摸屏设备
			if ('ontouchstart' in window || navigator.maxTouchPoints) {
				this.isTouchDevice = true;
				this.flipHintText = '👆 轻点名片 → 翻转查看背面';
			} else {
				this.flipHintText = '🖱️ 鼠标悬停翻转 | 点击可固定翻转/回正';
			}
		},
		methods: {
			handleQrClick(url) {
				if (url) {
					window.open(url, '_blank');
				}
			}
		}
	};
</script>

<style scoped>
	.double-cards-vertical {
		max-width: 750px;
		width: 100%;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		gap: 48px;
		padding: 40px 24px;
		min-height: 100vh;
		background: linear-gradient(145deg, #e0e5ec 0%, #cbd0d9 100%);
		box-sizing: border-box;
	}

	.card-wrapper {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.hint-wrapper {
		display: flex;
		justify-content: center;
		margin-top: 18px;
	}

	.flip-hint {
		text-align: center;
		font-size: 13px;
		color: #2c5f6e;
		background: rgba(255, 255, 240, 0.7);
		display: inline-block;
		width: auto;
		padding: 6px 14px;
		border-radius: 50px;
		backdrop-filter: blur(4px);
		letter-spacing: 1px;
		font-weight: 500;
	}
</style>